// **************************************************
// Scroll to top
// **************************************************

const topButton = document.querySelector('.top-button');

if (topButton) {
  topButton.addEventListener('click', (event) => {
    event.preventDefault();
    document.body.scrollIntoView({
      behavior: 'smooth',
    }, true);
  });

  // Show button when scrolling up
  let lastScrollTop = 0;

  document.addEventListener('scroll', () => {
    const st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > lastScrollTop) {
      topButton.classList.remove('button-active');
    } else {
      topButton.classList.add('button-active');
    }

    if (window.pageYOffset === 0) {
      topButton.classList.remove('button-active');
    }

    lastScrollTop = st <= 0 ? 0 : st;
  }, false);
}
